<template>
    <div class="col-12">
        <div class="loading-spinner-block">
            <b-spinner variant="success" label="Spinning"></b-spinner>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        }
    }
</script>
